#import "../fragments/inbound-facebook-rules-fragment.graphql"

query GetInboundFacebookRules($threadType: ThreadType!) {
    inboundFacebookRules(threadType: $threadType) {
        ...InboundFacebookRulesFragment
    }
}
